import React, { lazy, Suspense, useContext, useEffect, useMemo, useRef, useState } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom';
import Sidebar from './home/Sidebar';
import SupplymintHeader from './home/SupplymintHeader';
import { stacks, stackNames } from '../constants/routingStack'
import { stacksV2, stackNamesV2 } from '../constants/routingStackV2'
import ParentModal from '../genericComponents/ParentModal';
import Dashboard from './dashboard';
import Icons from '../assets/icons';
import CreateTicketModal from './helpSection/CreateTicketModal';
import '../styles/stylesheets/home/Dashboard.scss'
import html2canvas from 'html2canvas'
import UploadExcel from './uploadExcel/UploadExcel';
import { CreateFilterAndHeaderManagement } from '../authComponents/CreateFilterAndHeaderManagement';
import '../styles/stylesheets/helper.scss'
import FullPageLoader from '../loaders/FullPageLoader';
import AuditLogs from './AuditLogs';
import UserProfileHome from './home/profileSection/userProfile/UserProfileHome';
import ChangeSetting from './home/profileSection/changeSetting/ChangeSetting';
import { getMenuExpandMode, parseJwt } from '../helper/genericFunction';
import Annoucement from './helpSection/Annoucement';
import DefaultPopUp from './defaultPopUp/DefaultPopUp';
import SupportTickets from './superAdmin/SupportTickets';
import SocketComponent from '../socket/SocketComponent';
import { connectWithSocketConnection, disconnectWithSocketConnection, getSocketConnection } from '../socket/socketHelperConnection';
import LanguageTranslator from '../locals/LanguageTranslator';
import LanguagePopup from '../locals/LanguagePopup';
import { CONFIG } from '../config';
import AppTour from '../appTour/AppTour';
import { dispatchHandler } from '../helper/apiHelperFunctions';
import { useDispatch, useSelector } from 'react-redux';
import { UserDetailsContext } from '../App';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { getUpdatedModulesObject, setLocalStorageItems } from '../authComponents/login/LoginApiResponse';
import { CombinedProvider } from './contextProviders/CombinedContextProvider';
import { ContextHandlers } from './contextProviders/ContextHandlers';

import { GoogleAnalytics } from '../helper/components/GoogleAnalytics';
import Comments from './digiVend/Comments/Comments';
import NoPageFound from './helperComponents/NoPageFound';
import ExcelUploadLogs from './uploadExcel/ExcelUploadLogs';
import DataExportLogs from './DataExportLogs';
import { getNumberOfStrips } from '../initialPhaseOperations/InitialAnnouncementModal'
import {MainMenu, useMostBasicFirstPathForTheCurrentWorkspace } from './home/MainMenu';
import SwitcherLoader from './skeletons/SwitcherLoader';
import RequestOnboardingComponent from '../authComponents/vendorOnboarding/components/RequestOnboardingComponent';
import DataAPIMonitor from './dataAPIMonitoring/dataAPIMonitor';
import TaskManagerPage from './taskManager/TaskManagerPage';
import AdministrationAPILogs from './administration/apiLogs/AdministrationAPILogs';
import { consumeSsoTargetModule } from '../authComponents/login/helper/ssoLoginFunctions';

export const NeverResolve = lazy(() => new Promise(() => { }));


const CommentContext = React.createContext({
	unreadComments: null,
})

const TaskMentionsContext = React.createContext({
	totalUnreadMentions: 0,
	taskCountWithUnreadMentions: 0,
	mentions: [],
})

const AppStack = (props) => {
	const [selectedModal, setSelectedModal] = useState("");
	const [ssFile, setSsFile] = useState("");
	const history = useHistory()
	const dispatch = useDispatch();
	const location = useLocation();

	// State : To store the unread comments data;
	const [unreadComments, setUnreadComments] = useState(null);
	const [taskMentions, setTaskMentions] = useState({
		totalUnreadMentions: 0,
		taskCountWithUnreadMentions: 0,
		mentions: [],
	});
	const [userConfigLoading, setUserConfigLoading] = useState({
		"ent_details": true,
		"ent_modules": true,
		"new_main_menu_modules": true,
		"new_main_menu_admin_modules": true,
		"new_main_menu_mdm_modules": true,
	});
	const [moduleSwitchLoading, setModuleSwitchLoading] = useState({
		"new_main_menu_modules": true,
	})
	let getCurrrentUserEntModulesData = useSelector(state => state?.authStore?.getCurrrentUserEntModulesData);
	let getCurrrentUserEntDetailsData = useSelector(state => state?.authStore?.getCurrrentUserEntDetailsData);
	let getNewMainMenuModulesData = useSelector(state => state?.authStore?.getNewMainMenuModulesData);
	let getNewMainMenuAdminData = useSelector(state => state?.authStore?.getNewMainMenuAdminData);
	let getNewMainMenuMdmData = useSelector(state => state?.authStore?.getNewMainMenuMdmData);
	let getTabsConfigurationData = useSelector(state => state?.generalStore?.getTabsConfigurationData);
	const refreshTokenData = useSelector(state => state?.authStore?.refreshTokenData);
	const userConfigLoadingRef = useRef(userConfigLoading);
	const [errorData, setErrorData] = useState({});
	const [stripHeight, setStripHeight] = useState(getNumberOfStrips() || 0);

	let { userDetails, setUserDetails } = useContext(UserDetailsContext)
	const { getFirstPath } = useMostBasicFirstPathForTheCurrentWorkspace();
	const mainMenuModules = JSON.parse(userDetails?.mainMenu || "[]")
	const [currentActiveModule, setCurrentActiveModule] = useState(mainMenuModules?.activeModule);

	const currentModuleRef = useRef(currentActiveModule);
	useEffect(() => {
		getUnreadCommentCountForThisUser();
	}, [])

	useEffect(() => {
		setInterval(() => {
			setStripHeight(getNumberOfStrips())
		}, 400)
	}, [])

	const getUnreadCommentCountForThisUser = async () => {
		// on the mount of this component
		await fetch(`${CONFIG?.NOTIFICATION_ROUTE_PROD}/comment/getBatchedUnreadCommentCount`, {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
				"X-AUTH-TOKEN": sessionStorage.getItem("token"),
			},
		})
			?.then(response => response?.json())
			?.then(response => {
				if (response?.status === 200) {
					setUnreadComments(response?.data || {});
				}
			})
	}

	const getUserInformation = async () => {
		// on the mount of this component
		dispatchHandler(dispatch, "getCurrrentUserEntDetailsRequest", {
			flowType: "ENT_DETAILS",
			token: sessionStorage.getItem("token"),
		})
		dispatchHandler(dispatch, "getCurrrentUserEntModulesRequest", {
			flowType: "MODULES",
			token: sessionStorage.getItem("token"),
		})
		getNewMainMenuModulesRequest();
		getNewMainMenuAdminRequest();
		getNewMainMenuMdmRequest();
	}

	const getNewMainMenuModulesRequest = (moduleCode = "") => {
		console.log('getNewMainMenuModulesRequest running')
		setUserDetails(prev => {
			delete prev?.["mainMenu"]
			return prev;
		})
		let updatedUserConfigLoading = { ...(userConfigLoadingRef?.current || {}) }
		updatedUserConfigLoading["new_main_menu_modules"] = true;
		userConfigLoadingRef.current = updatedUserConfigLoading;
		setUserConfigLoading(updatedUserConfigLoading)
		setModuleSwitchLoading(updatedUserConfigLoading)
		setCurrentActiveModule(moduleCode);
		currentModuleRef.current = moduleCode

		dispatchHandler(dispatch, "getNewMainMenuModulesRequest", {
			flowType: "MODULES",
			moduleCode: moduleCode,
			token: sessionStorage.getItem("token"),
		})
		// Wipe out all the tabs information for the page from the local offline storage
		// wipeOutTabsInformationFromLocalStorage();
	}

	const getNewMainMenuAdminRequest = (moduleCode = "") => {
		// setUserDetails(prev => {
		// 	delete prev?.["mainMenu"]
		// 	return prev;
		// })
		let updatedUserConfigLoading = { ...(userConfigLoadingRef?.current || {}) }
		updatedUserConfigLoading["new_main_menu_admin_modules"] = true;
		userConfigLoadingRef.current = updatedUserConfigLoading;
		setUserConfigLoading(updatedUserConfigLoading)
		setModuleSwitchLoading(updatedUserConfigLoading)
		setCurrentActiveModule(moduleCode);
		currentModuleRef.current = moduleCode

		dispatchHandler(dispatch, "getNewMainMenuAdminRequest", {
			flowType: "MODULES",
			moduleCode: 'ADMIN',
			token: sessionStorage.getItem("token"),
		})
		// Wipe out all the tabs information for the page from the local offline storage
		// wipeOutTabsInformationFromLocalStorage();
	}

	const getNewMainMenuMdmRequest = (moduleCode = "") => {
		// setUserDetails(prev => {
		// 	delete prev?.["mainMenu"]
		// 	return prev;
		// })
		let updatedUserConfigLoading = { ...(userConfigLoadingRef?.current || {}) }
		updatedUserConfigLoading["new_main_menu_mdm_modules"] = true;
		userConfigLoadingRef.current = updatedUserConfigLoading;
		setUserConfigLoading(updatedUserConfigLoading)
		setModuleSwitchLoading(updatedUserConfigLoading)
		setCurrentActiveModule(moduleCode);
		currentModuleRef.current = moduleCode

		dispatchHandler(dispatch, "getNewMainMenuMdmRequest", {
			flowType: "MODULES",
			moduleCode: 'MDM',
			token: sessionStorage.getItem("token"),
		})
		// Wipe out all the tabs information for the page from the local offline storage
		// wipeOutTabsInformationFromLocalStorage();
	}

	// Function : To wipe out the tabs information for the page from the local offline storage
	// const wipeOutTabsInformationFromLocalStorage = async () => {
	// 	try {
	// 		// const db = await openDB("Supplymint-ai-offline-storage", 1);
	// 		// db.deleteObjectStore("MASTER_DB_TABS");
	// 		// db?.close?.();
	// 		// await createNewTabStore();
	// 	} catch (error) {
	// 		console.log("Error in wiping out the tabs information from the local offline storage", error)
	// 	}
	// }

	// const createNewTabStore = async () => {
	// 	let db = await openDB('Supplymint-ai-local-storage', 1, {
	// 		upgrade(db) {
	// 			db.createObjectStore("MASTER_DB_TABS");
	// 		}
	// 	});
	// 	db.close?.();
	// }

	useEffect(() => {
		userConfigLoadingRef.current = userConfigLoading;
	}, [userConfigLoading])

	useEffect(() => {
		getUnreadCommentCountForThisUser();

		getUserInformation();

		if (sessionStorage.getItem("switchOrgResponse")) {
			try {
				let switchData = JSON.parse(sessionStorage.getItem("switchOrgResponse")) || {};
				setLocalStorageItems(switchData, dispatch);
			} catch (err) {
				console.error("Failed to parse switchOrgResponse", err);
			}
		}
	}, [])

	useEffect(() => {
		if (!userConfigLoading?.["ent_details"] && !userConfigLoading?.["ent_modules"]) {
			if (sessionStorage.getItem("switchOrgResponse")) {
				sessionStorage.removeItem("switchOrgResponse");
			}
		}
	}, [userConfigLoading?.["ent_details"], userConfigLoading?.["ent_modules"]])

	useEffect(() => {
		if(refreshTokenData?.isSuccess){
			getNewMainMenuModulesRequest();
			getNewMainMenuAdminRequest();
			getNewMainMenuMdmRequest();
		}
	},[refreshTokenData?.isSuccess])

	useEffect(() => {
		if (getCurrrentUserEntModulesData?.isSuccess) {
			let data = getCurrrentUserEntModulesData?.data?.resource || {};
			let tokenData = parseJwt(sessionStorage.getItem("token"));
			setUserDetails(prev => {
				if (tokenData?.vendorOnboardingPage === 1 && tokenData?.eid == -1) {
					prev["modules"] = JSON.stringify([])
					prev["dashboardModules"] = JSON.stringify([]);
				} else {
					prev["modules"] = JSON.stringify(getUpdatedModulesObject(data?.["modules"]?.[0]) || [])
					prev["dashboardModules"] = JSON.stringify(data?.["dashboardModules"] || []);
				}
				return prev;
			})
			let updatedUserConfigLoading = { ...(userConfigLoadingRef?.current || {}) }
			delete updatedUserConfigLoading["ent_modules"];
			userConfigLoadingRef.current = updatedUserConfigLoading;
			setUserConfigLoading(updatedUserConfigLoading)
			setErrorData(errorData == null ? {} : {})
		}

		if (getCurrrentUserEntModulesData?.isError) {
			let updatedUserConfigLoading = { ...(userConfigLoadingRef?.current || {}) }
			delete updatedUserConfigLoading["ent_modules"];
			userConfigLoadingRef.current = updatedUserConfigLoading;
			setUserConfigLoading(updatedUserConfigLoading)
			setErrorData(errorData == null ? {} : {})
		}
	}, [getCurrrentUserEntModulesData])

	useEffect(() => {
		if (getCurrrentUserEntDetailsData?.isSuccess) {
			let data = getCurrrentUserEntDetailsData?.data?.resource || {};
			setUserDetails(prev => {
				let updatedData = prev?.["loginResponse"] ? JSON.parse(prev?.["loginResponse"]) : {};
				prev["loginResponse"] = JSON.stringify({
					...(updatedData || {}),
					entDetails: data?.["entDetails"]
				})
				return prev;
			})
			setErrorData(errorData == null ? {} : {})
			let updatedUserConfigLoading = { ...(userConfigLoadingRef?.current || {}) }
			delete updatedUserConfigLoading["ent_details"];
			userConfigLoadingRef.current = updatedUserConfigLoading;
			setUserConfigLoading(updatedUserConfigLoading)
		}

		if (getCurrrentUserEntDetailsData?.isError) {
			let updatedUserConfigLoading = { ...(userConfigLoadingRef?.current || {}) }
			delete updatedUserConfigLoading["ent_details"];
			userConfigLoadingRef.current = updatedUserConfigLoading;
			setUserConfigLoading(updatedUserConfigLoading)
			setErrorData(errorData == null ? {} : {})
		}
	}, [getCurrrentUserEntDetailsData])

	// handle the response of the new main menu modules
	useEffect(() => {
		// SSO login : switch (only once) to the module the user was redirected from
		const ssoTargetModule = getNewMainMenuModulesData?.isSuccess && consumeSsoTargetModule(getNewMainMenuModulesData?.data?.resource?.newModuleData);
		if (ssoTargetModule) {
			getNewMainMenuModulesRequest(ssoTargetModule);
		} else if (getNewMainMenuModulesData?.isSuccess) {
			let data = getNewMainMenuModulesData?.data?.resource || {};
			let tokenData = parseJwt(sessionStorage.getItem("token"));
			let updatedUsersDetails = null;
			setUserDetails(prev => {
				if (tokenData?.vendorOnboardingPage === 1 && tokenData?.eid == -1) {
					prev["mainMenu"] = JSON.stringify([])
				} else {
					prev["mainMenu"] = JSON.stringify(data?.newModuleData || [])
				}
				updatedUsersDetails = prev;
				return prev;
			})
			let updatedUserConfigLoading = { ...(userConfigLoadingRef?.current || {}) }
			delete updatedUserConfigLoading["new_main_menu_modules"];
			userConfigLoadingRef.current = updatedUserConfigLoading;

			// get the tabs informatioon for the page as well
			if (data?.newModuleData?.activeModule) {
				setCurrentActiveModule(data?.newModuleData?.activeModule);
				currentModuleRef.current = data?.newModuleData?.activeModule
				updatedUserConfigLoading["new_main_menu_modules_tabs"] = true
				getTabsInformation(data?.newModuleData?.activeModule)
			}

			setUserConfigLoading(updatedUserConfigLoading)
			// Redirection logic to avoid dashboard loader.
			// A pending navigation (set by chooseWorkspace when a menu item
			// targets a different workspace than the active one) must be honored
			// for ANY module switch, not just ADMIN/MDM — otherwise a cross-module
			// click (e.g. a proc page opened from the Reports panel) switches the
			// workspace but then lands on that module's first page or NoPageFound.
			// currentModuleRef.current is already updated above, so the target
			// module's routes are mounted before we push.
			const pendingNav = sessionStorage.getItem("pending_admin_navigation");
			if (pendingNav) {
				sessionStorage.removeItem("pending_admin_navigation");
				sessionStorage.setItem("skip_admin_first_page_redirect", "true");
				history.push(pendingNav);
			} else if (data?.newModuleData?.activeModule === 'ADMIN' || data?.newModuleData?.activeModule === 'MDM') {
				const firstPath = getFirstPath(updatedUsersDetails);
				if (firstPath) history.push(firstPath);
			}
			// setTimeout(() => {
			// 	setModuleSwitchLoading(updatedUserConfigLoading)
			// }, 900);
		}

		if(getNewMainMenuAdminData?.isSuccess) {
			let data = getNewMainMenuAdminData?.data?.resource || {};
			let tokenData = parseJwt(sessionStorage.getItem("token"));
			let updatedUsersDetails = null;
			setUserDetails(prev => {
				if (tokenData?.vendorOnboardingPage === 1 && tokenData?.eid == -1) {
					prev["adminModules"] = JSON.stringify([])
				} else {
					prev["adminModules"] = JSON.stringify(data?.newModuleData || [])
				}
				updatedUsersDetails = prev;
				return prev;
			})
			let updatedUserConfigLoading = { ...(userConfigLoadingRef?.current || {}) }
			delete updatedUserConfigLoading["new_main_menu_admin_modules"];
			userConfigLoadingRef.current = updatedUserConfigLoading;

			// NOTE: do not call getTabsInformation or overwrite
			// currentActiveModule here. The admin response always carries
			// activeModule="ADMIN" (it's a side dataset for the hover overlay),
			// so doing so would clobber the real workspace (e.g. MDM/DIGIPROC)
			// and fire a tabs request with the wrong activeModule on every
			// switch. Tabs are handled by the modules success branch above.

			// setUserConfigLoading(updatedUserConfigLoading)
			// Redirection logic to avoid dashboard loader
			// const firstPath = getFirstPath(updatedUsersDetails);
			// if (firstPath && (data?.newModuleData?.activeModule === 'ADMIN' || data?.newModuleData?.activeModule === 'MDM')) {
			// 	history.push(firstPath);
			// }
			// setTimeout(() => {
			// 	setModuleSwitchLoading(updatedUserConfigLoading)
			// }, 900);
		}

		if(getNewMainMenuMdmData?.isSuccess) {
			let data = getNewMainMenuMdmData?.data?.resource || {};
			let tokenData = parseJwt(sessionStorage.getItem("token"));
			let updatedUsersDetails = null;
			setUserDetails(prev => {
				if (tokenData?.vendorOnboardingPage === 1 && tokenData?.eid == -1) {
					prev["mdmModules"] = JSON.stringify([])
				} else {
					prev["mdmModules"] = JSON.stringify(data?.newModuleData || [])
				}
				updatedUsersDetails = prev;
				return prev;
			})
			let updatedUserConfigLoading = { ...(userConfigLoadingRef?.current || {}) }
			delete updatedUserConfigLoading["new_main_menu_mdm_modules"];
			userConfigLoadingRef.current = updatedUserConfigLoading;
		}

		if (getNewMainMenuModulesData?.isError) {
			let updatedUserConfigLoading = { ...(userConfigLoadingRef?.current || {}) }
			delete updatedUserConfigLoading["new_main_menu_modules"];
			userConfigLoadingRef.current = updatedUserConfigLoading;
			setUserConfigLoading(updatedUserConfigLoading)
			setTimeout(() => {
				setModuleSwitchLoading(updatedUserConfigLoading)
			}, 900);
			setErrorData(errorData == null ? {} : {})
		}
	}, [getNewMainMenuModulesData, getNewMainMenuAdminData?.isSuccess, getNewMainMenuMdmData?.isSuccess])


	useEffect(() => {
		if (getTabsConfigurationData?.isSuccess) {
			let updatedUserConfigLoading = { ...(userConfigLoadingRef?.current || {}) }
			delete updatedUserConfigLoading["new_main_menu_modules_tabs"];
			userConfigLoadingRef.current = updatedUserConfigLoading;
			setUserConfigLoading(updatedUserConfigLoading)
			setTimeout(() => {
				setModuleSwitchLoading(updatedUserConfigLoading)
			}, 900);
		}

		if (getTabsConfigurationData?.isError) {
			let updatedUserConfigLoading = { ...(userConfigLoadingRef?.current || {}) }
			delete updatedUserConfigLoading["new_main_menu_modules_tabs"];
			userConfigLoadingRef.current = updatedUserConfigLoading;
			setUserConfigLoading(updatedUserConfigLoading)
			setTimeout(() => {
				setModuleSwitchLoading(updatedUserConfigLoading)
			}, 900);
			setErrorData(errorData == null ? {} : {})
		}
	}, [getTabsConfigurationData])

	useEffect(() => {
		window.addEventListener('storage', (event) => {
			let tokenData = parseJwt(sessionStorage.getItem("token"));
			if (event.key === 'refresh_all_tabs' && (event.newValue === `new_${tokenData.jti}` || event.newValue === `old_${tokenData.jti}`)) {
				//   Go to dashboard
				history.push(event.newValue?.includes('new') ? '/app' : '/home')
				// setTimeout(() => {
				window.location.reload();
				// },200),
			}
		});
	}, [])

	useEffect(() => {
		let socket = getSocketConnection();
		if (socket?.connected) {
			socket.on("new_comment_addition", (data) => {
				if (data?.documentId && data?.documentNumber) {
					let updatedUnreadComments = { ...unreadComments };
					if (!updatedUnreadComments) { updatedUnreadComments = {} }
					updatedUnreadComments[`${data?.["documentId"]}-${data?.["documentNumber"]}`] = Number(updatedUnreadComments[`${data?.["documentId"]}-${data?.["documentNumber"]}`] || "") + 1;
					setUnreadComments(updatedUnreadComments);
				}
			})
		}
		return () => {
			let socket = getSocketConnection();
			if (socket?.connected) {
				socket.off("new_comment_addition");
			}
		}
	}, [])

	// Function : To get the tabs information
	const getTabsInformation = (code) => {
		dispatchHandler(dispatch, "getTabsConfigurationRequest", {
			activeModule: code,
		}, {
			"X-Scope-Id": "common.commonfunctionality.view"
		})
	}

	const getMenuMode = () => {
		let tokenData = parseJwt(sessionStorage.getItem("token"));
		let menuMode = localStorage.getItem(`menuMode-${tokenData?.jti}`);
		return menuMode;
	}

	// To handle the selection of modal

	// To provide the routing routes
	const renderStackRouting = (stackName, type) => {
		let updatedStacks = getMenuMode() == "new" ? stacksV2 : stacks;
		let updatedStackNames = getMenuMode() == "new" ? stackNamesV2 : stackNames;
		// console.log("Chek23",Object.keys(updatedStacks?.[stackName] || {}))
		return updatedStacks?.[stackName]?.[type]?.map((path) => {
			// console.log("Stack name check", stackName, type, path,  getMenuMode() == "new", updatedStackNames?.[type]);
			return <Route exact path={path} component={updatedStackNames?.[type]} />
		})
	}

	useEffect(() => {
		connectWithSocketConnection({
			history,
			location,
			setUnreadComments,
			unreadComments
		});

		const socket = getSocketConnection();

		const handleConnect = () => {
			socket.on("new_comment_addition", (data) => {
				if (data?.documentId && data?.documentNumber) {
					const key = `${data?.["documentId"]}-${data?.["documentNumber"]}`;
					setUnreadComments((prev) => ({
						...(prev || {}),
						[key]: Number(prev?.[key] || "") + 1,
					}));
				}
			});

			socket.on("get_my_task_mentions", (res) => {
				setTaskMentions({
					totalUnreadMentions: res?.totalUnreadMentions || 0,
					taskCountWithUnreadMentions: res?.taskCountWithUnreadMentions || 0,
					mentions: res?.mentions || [],
				});
			});

			socket.on("show_notification", (payload) => {
				if (payload?.type !== "mention_show_notification") return;
				setTaskMentions((prev) => {
					const alreadyHasTask = (prev.mentions || []).some((m) => String(m.documentId) === String(payload.documentId));
					return {
						totalUnreadMentions: (prev.totalUnreadMentions || 0) + 1,
						taskCountWithUnreadMentions: (prev.taskCountWithUnreadMentions || 0) + (alreadyHasTask ? 0 : 1),
						mentions: [
							{
								commentId: payload.commentId,
								documentId: payload.documentId,
								documentNumber: payload.documentNumber,
								commentBody: payload.commentBody,
								taggedByUserName: payload.fullName,
								creationTime: payload.creationTime,
								status: payload.status || "PENDING",
								isRead: false,
							},
							...(prev.mentions || []),
						],
					};
				});
			});

			socket.on("store_user_read_time", (res) => {
				if (res?.documentId != null && res?.documentNumber != null) {
					setUnreadComments((prev) => {
						const key = `${res.documentId}-${res.documentNumber}`;
						if (!prev?.[key]) return prev;
						return { ...prev, [key]: 0 };
					});
				}
				setTaskMentions((prev) => {
					let unreadTurnedRead = 0;
					const updated = (prev.mentions || []).map((m) => {
						if (String(m.documentId) !== String(res?.documentId) || m.isRead) return m;
						unreadTurnedRead += 1;
						return { ...m, isRead: true };
					});
					if (!unreadTurnedRead) return prev;
					return {
						totalUnreadMentions: Math.max(0, (prev.totalUnreadMentions || 0) - unreadTurnedRead),
						taskCountWithUnreadMentions: Math.max(0, (prev.taskCountWithUnreadMentions || 0) - 1),
						mentions: updated,
					};
				});
			});
		};

		// Attach the event listener only after socket connects
		if (socket?.connected) {
			handleConnect();
		} else {
			socket.on('connect', handleConnect); // Attach listener on 'connect' event
		}

		const hydrateTaskMentions = () => {
			socket.emit("get_my_task_mentions", {});
		};
		socket.on("connect", hydrateTaskMentions);
		if (socket?.connected) {
			hydrateTaskMentions();
		}

		return () => {
			if (socket) {
				socket.off("show_notification");
				socket.off("new_comment_addition");
				socket.off("get_my_task_mentions");
				socket.off("store_user_read_time");
				socket.off("connect", hydrateTaskMentions);
			}
			disconnectWithSocketConnection();
		};
	}, []);

	const renderRouting = () => {

		switch (getMenuMode?.()) {
			case "new": {
				console.log('currentModuleRef1212', currentModuleRef)
				return Object.keys(stacksV2?.[currentModuleRef?.current || ""] || {})?.map(key => (
					renderStackRouting(currentModuleRef?.current || "", key)
				))
			}
			default: {
				let modules = JSON.parse(userDetails?.modules || "[]");
				let allModulesNames = modules?.map(item => item?.code);
				return allModulesNames?.map(stackName => Object.keys(stacks?.[stackName] || {})?.length > 0 && (
					// If the stack is available for the given routes;
					Object.keys(stacks?.[stackName])?.map(key => (
						renderStackRouting(stackName, key)
					))
				))
			}
		}
	}

	const memoizedRoutes = useMemo(() => renderRouting(), [
		currentModuleRef.current,
		userDetails?.modules,
		getMenuMode?.()
	]);

	useEffect(() => {
		let parseToken = parseJwt(sessionStorage.getItem('token'))
		if (sessionStorage.getItem("showEthanacityPopUp") && parseToken?.schemaEntID == "3152" && parseToken?.uType?.toUpperCase() == "VENDOR") {
			setSelectedModal("annoucement");
		}
	}, [])

	const getParentChildProps = () => {
		switch (selectedModal) {
			case "createTicketModal": {
				return {
					closeModal: () => { setSelectedModal(false) },
					// postitionProps: { top: '50%', left: '50%',transform: 'translate(-50%, -50%)', margin: 0, position: "fixed", borderRadius: 4 },
					parentModalOuterMostClassName: 'flex items-center justify-center',
					postitionProps: { position: 'relative' },
					dimensions: { width: "56vw", height: "70vh", maxHeight: '580px', maxWidth: '810px' },
					animationType: "bottom",
					ssFile: ssFile
				}
			}
			case "annoucement": {
				return {
					closeModal: () => { setSelectedModal(false) },
					// postitionProps: { top: '50%', left: '50%',transform: 'translate(-50%, -50%)', margin: 0, borderRadius: 4 },
					parentModalOuterMostClassName: 'flex items-center justify-center',
					postitionProps: { position: 'relative' },
					dimensions: { width: "50vw", height: "80vh", maxHeight: '660px', maxWidth: '730px' },
					animationType: "bottom",
				}
			}
			default:
		}
	}

	const getChildComponent = () => {
		switch (selectedModal) {
			case "createTicketModal": return CreateTicketModal;
			case "annoucement": return Annoucement
			default:
		}
	}

	const captureSS = () => {
		// $("#create_new_ticket").css("visibility", "hidden");
		let app = document.getElementById("app");
		html2canvas(app).then(canvas => {
			canvas.toBlob(blob => {
				let time = (new Date()).getTime();
				let fileName = `SMSS_${time}.png`;
				let updatedSsFile = new File([blob], fileName, { type: "image/png" });
				setSsFile(updatedSsFile)
				// $("#create_new_ticket").css("visibility", "visible")
			});
		})
	}

	const handleChange = (type, data) => {
		switch (type) {
			case "createTicketModal": {
				captureSS();
				setSelectedModal(type);
			}
		}

	}

	if (userConfigLoading?.["ent_details"] || userConfigLoading?.["ent_modules"]) {
		return sessionStorage.getItem("switchOrgResponse") ?
			<FullPageLoader type="switchOrg" />
			: <div className='w-full h-screen bg-white flex items-center justify-center'>
				<div className='space-y-2 text-center'>
					<Icons.InfiniteLoop className='h-[30px] w-auto mx-auto mb-5' />
					<p className='text-fontBlack text-[19px] font-semibold mb-0'><LanguageTranslator>Loading Your Experience</LanguageTranslator>...</p>
					<p className='text-fontGrey text-[13px]'>“ <LanguageTranslator>We're getting things ready for you!</LanguageTranslator> ”</p>
				</div>
			</div>
	}

	if (getMenuMode?.() == "new" && (moduleSwitchLoading?.["new_main_menu_modules"] || moduleSwitchLoading?.["new_main_menu_modules_tabs"] || userConfigLoading?.["new_main_menu_modules"] || userConfigLoading?.["new_main_menu_modules_tabs"])) {
		// Render the switcher loader here
		return <SwitcherLoader moduleName={currentActiveModule} isLoading={userConfigLoading?.["new_main_menu_modules"] || userConfigLoading?.["new_main_menu_modules_tabs"]} />
	}

	const topHeight = 45 + Number(stripHeight || 0);

	// Resolve the first active page for the current workspace (respects the user's menu config).
	// Falls back to the default dashboard only when no active path is found.
	const resolvedFirstPath = getFirstPath?.();
	const firstActivePath = (resolvedFirstPath && resolvedFirstPath !== '/app')
		? resolvedFirstPath
		: (getMenuMode?.() == 'new' ? '/app' : '/home');

	return (
		<TaskMentionsContext.Provider value={taskMentions}>
		<CommentContext.Provider value={{
			unreadComments: unreadComments,
			setUnreadComments: (val) => setUnreadComments(val),
			getUnreadCommentCountForThisUser: getUnreadCommentCountForThisUser
		}}>
			<CombinedProvider>
				{/* Render the Side Bar Component */}
				{getMenuMode?.() === 'new' ? <MainMenu
					userConfigLoading={userConfigLoading}
					setUserConfigLoading={setUserConfigLoading}
					userConfigLoadingRef={userConfigLoadingRef}
					getNewMainMenuModulesRequest={getNewMainMenuModulesRequest}
					getNewMainMenuAdminRequest={getNewMainMenuAdminRequest}
					getNewMainMenuMdmRequest={getNewMainMenuMdmRequest}
					setCurrentActiveModule={setCurrentActiveModule}
					currentActiveModule={currentActiveModule}
					currentModuleRef={currentModuleRef}
				/> : <Sidebar />}

				{/* <div className='absolute right-[0] h-screen w-[calc(100vw-63px)]'><FullPageLoader /></div> */}
				<Suspense fallback={<FullPageLoader style={{ zIndex: 989, float: 'right', width: getMenuMode() == "new" ? getMenuExpandMode(userDetails) === 'reports' ? `calc(100% - 311px)` : getMenuExpandMode(userDetails) === 'settings' ? `calc(100% - 187px)` : 'calc(100% - 63px)' : '' }} />}>

					{/* Force fallback to always show */}
					{/* <NeverResolve /> */}

					{/* The Context Handler Comes here */}
					<ContextHandlers />
					{/* To send the google analytics */}
					{/* process.env.REACT_APP_NODE_ENV === "production" && */}
					{<GoogleAnalytics />}

					{/* To handle the language pop up */}
					<LanguagePopup type={2} />

					{/* To handle the language pop up */}
					<LanguagePopup type={2} />

					{/* Component : To handle the default pop up modals when the user comes to the application */}
					<DefaultPopUp />

					{/* To Handle the Filter and Headers api response */}
					<CreateFilterAndHeaderManagement />

					{/* Render the socket component for all realtine actions inside this */}
					<SocketComponent />

					{/* Render the Top Headers of Supplymint Portal */}

					<SupplymintHeader className={`transition-[padding] duration-200 ${getMenuExpandMode(userDetails) === 'reports' ? 'pl-[252px]' : getMenuExpandMode(userDetails) === 'settings' ? 'pl-[167px]' : ''}`} unreadComments={unreadComments} setCurrentDocumentState={props.setCurrentDocumentState} createNewTicket={() => handleChange("createTicketModal")} {...props} />

					<div className='table-component-div1 transition-[padding] duration-200' style={{ minHeight: `calc(100vh - ${topHeight}px)`, paddingLeft: getMenuExpandMode(userDetails) === 'reports' ? '296px' : getMenuExpandMode(userDetails) === 'settings' ? '210px' : '' }}>
						{/* Set up the module routes */}
						<Switch>
							{/* {memoizedRoutes} */}
							{renderRouting()}
							<Redirect exact from="/app" to={firstActivePath} />
							<Route exact path="/excel-upload" component={UploadExcel} />
							<Route exact path="/excel-upload-logs" component={ExcelUploadLogs} />
							<Route exact path="/dataExportLogs" component={DataExportLogs} />
							<Route exact path="/excel-upload-proc" render={() => <UploadExcel isFromProc={true} />} /> 
							<Route exact path="/auditLogs" component={AuditLogs} />
							<Route path={getMenuMode?.() == 'new' ? '/app/product/:id/dashboard' : '/home'} render={() => <Dashboard {...props} />} /> 
							<Route path="/profile" component={UserProfileHome} />
							<Route path="/changeSetting" component={ChangeSetting} />
							<Route exact path="/settings/manageSupportTicket" render={() => <SupportTickets type="header" />} />
							<Route exact path="/central/comment" render={() => <Comments />} />
							<Route exact path="/vendor/request/onboarding" render={() => <RequestOnboardingComponent />} />
							<Route exact path="/data-api-monitor" component={DataAPIMonitor} />
							<Route exact path="/task-manager" component={TaskManagerPage} />
							<Route exact path="/app/data/settings/logs/api" render={() => <AdministrationAPILogs {...props} />} />
							<Route path='*' component={NoPageFound} />
						</Switch>
					</div>

					{/* The Create New Ticket Modal function will be available for all the windows */}
					<div id="globalAddMoreBtn" className="add-more-btn-home">
						<div className='gct-icon'>
							<div className="gct-plus">
								<Icons.PlusIcon />
							</div>
							<div className='amb-drop-tckt' onClick={() => handleChange("createTicketModal")}>
								<div className="create-gen-ticket">
									<Icons.CreateNewTicketIcon />
									<LanguageTranslator tag="p">Create Ticket</LanguageTranslator>
								</div>
							</div>
						</div>
					</div>
					{selectedModal && <ParentModal
						getParentChildProps={getParentChildProps()}
						childComponent={getChildComponent()}
						closeModal={() => { setSelectedModal(false) }}
					/>}
					<AppTour location={location} />
				</Suspense>
			</CombinedProvider>
		</CommentContext.Provider>
		</TaskMentionsContext.Provider>
	)
}

export { AppStack, CommentContext, TaskMentionsContext }